import { Button } from '@clearcover/atlas';
import React, { FC } from 'react';
import NavigationPrompt from 'react-router-navigation-prompt';
import { Modal } from 'Shared/components/Modal';
import styles from './styles.module.css';

type BlockNavPromptProps = {
  when: boolean;
  header: string;
  content: string;
};

export const BlockNavPrompt: FC<BlockNavPromptProps> = ({
  when,
  header,
  content,
}) => {
  return (
    <NavigationPrompt when={when}>
      {({ onCancel }) => (
        <Modal showModal onClose={onCancel} data-testid="block-nav-prompt">
          <div className={styles.modalContainer}>
            <h1 className={styles.header}>{header}</h1>
            <p className={styles.content}>{content}</p>
            <div className={styles.footer}>
              <Button onClick={onCancel} data-testid="cancel-block-nav-modal">
                Close
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </NavigationPrompt>
  );
};
